import { useQuery } from '@tanstack/react-query';

import { getCampaign } from 'apis/restaurant-api/merchant-admin/campaigns/api';
import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import { CampaignsQueryKeys } from '../campaignsQueryKeys';

export const useCampaign = ({
  merchantId,
  campaignId,
  enabled,
}: {
  merchantId: string;
  campaignId: string;
  enabled: boolean;
}) => {
  const { data: campaign, isLoading: isCampaignLoading } = useQuery(
    CampaignsQueryKeys.GET_SINGLE(merchantId, campaignId),
    () =>
      getCampaign(merchantId, campaignId).then(campaign => ({
        ...campaign,
        campaign_type: campaign.is_end_of_day_campaign ? CampaignType.END_OF_DAY : campaign.campaign_type,
      })),
    {
      refetchOnWindowFocus: false,
      enabled: enabled && !!merchantId && !!campaignId,
      retry: false,
    },
  );
  return { campaign, isCampaignLoading };
};
